import {isPossiblePhoneNumber} from 'libphonenumber-js';
import {getFlag, getFormatedPhoneNumber} from '../../../utilis/msisdnUtilis';
import {getFullName} from '../../../utilis/getFullName';
import type {CallIdentity} from './types';

export interface CallerRecord {
    readonly firstName?: string;
    readonly lastName?: string;
    readonly displayName?: string;
    readonly name?: string;
    readonly msisdn?: string | number;
    readonly phoneNumber?: string | number;
    readonly avatarUrl?: string;
    readonly iconColor?: string;
    readonly color?: string;
    readonly contactType?: {readonly source?: string};
    readonly url?: string;
    readonly userId?: string | number;
    readonly contactId?: number;
}

export type CallerSource = CallerRecord | string | null | undefined;

const PERSON_NAME = /^[\p{L}][\p{L}\p{M}\s.'-]*$/u;
const UNAVAILABLE = 'unavailable';

const digitsOf = (value: string | number | undefined): string | undefined =>
    value === undefined || value === null ? undefined : String(value).replace(/^\+/, '');

const isPhoneNumber = (digits: string | undefined): digits is string =>
    !!digits && (isPossiblePhoneNumber(`+${digits}`) || isPossiblePhoneNumber(digits));

const recordName = (record: CallerRecord): string | undefined =>
    getFullName(record.firstName ?? '', record.lastName ?? '').trim() || record.displayName || record.name || undefined;

export const resolveCallIdentity = (caller: CallerSource, fallbackNumber?: string | number): CallIdentity => {
    const record = caller && typeof caller === 'object' ? caller : undefined;
    const text = typeof caller === 'string' && caller !== UNAVAILABLE ? caller.trim() : undefined;
    const name = record ? recordName(record) : text && PERSON_NAME.test(text) ? text : undefined;
    const digits = digitsOf(record?.msisdn ?? record?.phoneNumber ?? (text && !name ? text : undefined) ?? fallbackNumber);
    const number = isPhoneNumber(digits) ? getFormatedPhoneNumber(digits, false) : undefined;
    return {
        name,
        number,
        flag: !name && isPhoneNumber(digits) ? getFlag(Number(digits)) || undefined : undefined,
        avatarUrl: record?.avatarUrl,
        color: record?.iconColor ?? record?.color,
        userId: record?.userId === undefined || record.userId === null ? undefined : String(record.userId),
        pipedriveUrl: record?.contactType?.source === 'PIPEDRIVE' ? record.url : undefined,
        contactId: typeof record?.contactId === 'number' ? record.contactId : undefined,
    };
};

export const initialsOf = (identity: CallIdentity): string => {
    const words = (identity.name ?? '').split(/\s+/).filter(Boolean);
    if (words.length === 0) {
        return '';
    }
    const first = words[0][0] ?? '';
    const last = words.length > 1 ? words[words.length - 1][0] ?? '' : '';
    return `${first}${last}`.toUpperCase();
};
